import React from 'react'

export const Backend = () => {
  return (
    <div className="skills--content backend">
      <h3 className="skills--title">Backend Development</h3>

      <div className="skills--box">
        
        <div className="skills--group">
          <div className="skills--data">
            <i class='bx bx-badge-check'></i>
            <div>
              <h3 className="skills--name">Java</h3>
              <span className="skills--level">Intermediate</span>
            </div>
          </div>
          <div className="skills--data">
            <i class='bx bx-badge-check'></i>
            <div>
              <h3 className="skills--name">MySQL</h3>
              <span className="skills--level">Intermediate</span>
            </div>
          </div>
          <div className="skills--data">
            <i class='bx bx-badge-check'></i>
            <div>
              <h3 className="skills--name">NodeJS</h3>
              <span className="skills--level">Basic</span>
            </div>
          </div>
        </div>

        <div className="skills--group">
          <div className="skills--data">
            <i class='bx bx-badge-check'></i>
            <div>
              <h3 className="skills--name">MongoDB</h3>
              <span className="skills--level">Basic</span>
            </div>
          </div>
          <div className="skills--data">
            <i class='bx bx-badge-check'></i>
            <div>
              <h3 className="skills--name">Firebase</h3>
              <span className="skills--level">Basic</span>
            </div>
          </div>
          <div className="skills--data">
            <i class='bx bx-badge-check'></i>
            <div>
              <h3 className="skills--name">ExpressJS</h3>
              <span className="skills--level">Intermediate</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}
